<template>
  <div class="ucrs-doughnut">
    <AsyncDoughnutChart :chart-data="computedData" :options="options" />
  </div>
</template>

<script>
import AsyncDoughnutChart from './chartjs/DoughnutChart'

export default {
  components: {
    AsyncDoughnutChart,
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      options: {
        responsive: true,
        legend: {
          display: false,
        },
        tooltips: false,
        hover: { mode: null },
        cutoutPercentage: 65,
        elements: {
          arc: {
            borderWidth: 0,
          },
        },
      },
      chartData: {
        datasets: [
          {
            data: [10, 20, 30],
            backgroundColor: [
              'rgb(255, 99, 132)',
              'rgb(255, 205, 86)',
              'rgb(54, 162, 235)',
            ],
          },
        ],
        labels: ['Red', 'Yellow', 'Blue'],
      },
    }
  },
  computed: {
    computedData() {
      const data = { datasets: [{ data: [], backgroundColor: [] }], labels: [] }

      this.items.forEach((item, i) => {
        data.datasets[0].data.push(item.qt)
        data.datasets[0].backgroundColor.push(item.color)
        data.labels.push(item.desc)
      })

      return data
    },
  },
}
</script>
